/* Decides whether the native bottom tab bar should be rendered on a given
 * route. Mirrors the per-screen `tabBarVisible` logic in the React Native
 * app's MainTabNavigator — inner / flow screens hide the bar so the page
 * gets the full viewport. Tab roots and a small allow-list of sub-screens
 * keep it visible.
 *
 * Used by both NativeTabBar (to skip rendering) and Layout (to drop the
 * bottom content padding) so a single source of truth controls both.
 *
 * Substring matching is used rather than full URL_PATTERNS values because
 * the latter include the variable country prefix (`/au/`, `/uk/`...) and
 * some include `:uid/:token` placeholders that don't match real URLs. */

const HIDE_FRAGMENTS: string[] = [
  // Auth flow
  "/welcome/",
  "/login/",
  "/login-verification/",
  "/logout/",
  "/signup/",
  "/password-reset/",
  "/set-new-password/",
  "/auto-login/",
  "/verify-email/",

  // Quiz flow
  "/quiz/",
  "/beer/quiz/",
  "/select-welcome-pack/",

  // Checkout / order completion / force reload
  "/checkout/",
  "/checkout-thank-you/",
  "/reload/",

  // Note: mobile RN hides the bar on /wines/details/ and /products/details/
  // because each detail screen has a stack header with a back arrow. The
  // web port has no such header, so hiding the bar leaves the user
  // stranded — keep it visible on detail pages until we add a back
  // affordance.
];

/* Substrings that should keep the bar visible even though they fall under a HIDE fragment. */
const SHOW_OVERRIDES: string[] = [];

export const shouldHideTabBar = (pathname: string): boolean => {
  if (SHOW_OVERRIDES.some((s) => pathname.includes(s))) return false;
  return HIDE_FRAGMENTS.some((s) => pathname.includes(s));
};
